import { Helmet } from "react-helmet-async";

const SITE_URL = "https://cogni.group";

interface SEOProps {
  path: string;
  title?: string;
  description?: string;
  noindex?: boolean;
}

export function SEO({ path, title, description, noindex }: SEOProps) {
  const canonical = `${SITE_URL}${path}`;
  return (
    <Helmet>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={canonical} />
      <meta property="og:url" content={canonical} />
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="twitter:description" content={description} />}
      {noindex && <meta name="robots" content="noindex, nofollow" />}
    </Helmet>
  );
}
